import { Controller } from '@hotwired/stimulus';
import { enter, leave } from '../transition';

export default class extends Controller {
    static targets = ['mobileBackdrop', 'mobileContainer', 'mobilePanel'];

    async closeMobilePanel() {
        if (this.transitioning || this.mobileContainerTarget.classList.contains('hidden')) return;
        this.transitioning = true;
        try {
            await Promise.all([
                leave(this.mobileBackdropTarget),
                leave(this.mobilePanelTarget),
            ]);
            this.mobileContainerTarget.classList.add('hidden');
        } finally {
            this.transitioning = false;
        }
    }

    async openMobilePanel() {
        if (this.transitioning || !this.mobileContainerTarget.classList.contains('hidden')) return;
        this.transitioning = true;
        try {
            this.mobileContainerTarget.classList.remove('hidden');
            await Promise.all([
                enter(this.mobileBackdropTarget),
                enter(this.mobilePanelTarget),
            ]);
        } finally {
            this.transitioning = false;
        }
    }
}
